/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface CreditorAccount1 {
  schemeName: string;
  identification: string;
  name: string;
}

export const creditorAccount1Schema: Schema<CreditorAccount1> = object({
  schemeName: ['SchemeName', string()],
  identification: ['Identification', string()],
  name: ['Name', string()],
});
